<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-layout xs4 mb-2>
          <v-flex mt-4>
            <h1>Gestão de Notificações</h1>
            <h3>Nova notificação > Notificação avulsa > Listagem de cotas</h3>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <hr class="solid" />
    <v-layout>
      <v-layout column mt-3 class="card">
        <v-card>
          <v-card-title>
            <v-row>
              <v-col cols="3">
                <v-btn
                    color="primary"
                    class="button btn-default white--text"
                    @click="dialog = true"
                >
                  Filtros
                </v-btn
                >
              </v-col>
              <v-col cols="6" offset="3">
                <v-autocomplete
                    v-model="selectedHeaders"
                    :items="headers"
                    label="Colunas Selecionadas"
                    multiple
                    outlined
                    return-object
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index < 4">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span v-if="index === 4" class="grey--text text-caption"
                    >(+{{ selectedHeaders.length - 4 }} others)</span
                    >
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-data-table
                    :headers="showHeaders"
                    :items="cotas"
                    :footer-props="{
                      'items-per-page-options': [10, 25, 50, -1]
                    }"
                    :items-per-page="10"
                    show-select
                    class="elevation-1"
                    item-key="id"
                    v-model="selected"
                    :single-select="false"
                >
                </v-data-table>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-btn
                    color="primary"
                    class="button btn-default white--text"
                    :disabled="selected.length === 0"
                    @click="incluirCotas()"
                >
                  {{ selected.length }}&nbsp;Cotas Selecionadas<span
                      v-if="selected.length > 0"
                  >, Incluir</span
                  >
                </v-btn
                >
              </v-col>
              <v-col cols="3" offset="6">
                <v-btn
                    color="primary"
                    class="button btn-default white--text"
                    @click="criarNotificacao()"
                    :disabled="cotasIncluidas.length === 0"
                >
                  Criar Notificação
                </v-btn
                >
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-layout>
    <v-dialog
        v-model="dialog"
        width="900"
        :scrollable="true"
        content-class="app-content"
        persistent
    >
      <v-card style="border-radius: 16px">
        <v-card-title class="text-h5">
          <v-flex class="d-flex">
            <v-flex>Filtros</v-flex>
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon @click="dialog = false">
                  <v-icon>fa fa-times</v-icon>
                </v-btn>
              </template>
            </v-menu>
          </v-flex>
        </v-card-title>
        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="6">
              <v-autocomplete
                  :items="filtrosOrdenados"
                  label="Opções de Filtro"
                  outlined
                  item-text="text"
                  item-value="value"
                  v-model="filtroPreenchido.nome"
                  @change="(valor) => retornaTipoCampoFiltro(valor)"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-text-field
                  :type="tipoFiltroSelecionado"
                  label="Valor"
                  placeholder="Valor"
                  outlined
                  v-model="filtroPreenchido.valor"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-btn
                  color="primary"
                  class="button btn-default white--text mt-4"
                  @click="incluirFiltro()"
              >
                Incluir
              </v-btn
              >
            </v-col>
          </v-row>
          <hr class="solid" />
          <v-alert
              dense
              type="info"
              v-if="filtrosIncluidos.length === 0"
              color="#0e6c3c"
          >
            Nenhum Filtro Adicionado
          </v-alert>
          <v-simple-table v-else class="elevation-1">
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Filtro</th>
                  <th>Valor</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="f in filtrosIncluidos" :key="f.nome">
                  <td>{{ f.descricao }}</td>
                  <td>{{ f.valor }}</td>
                  <td>
                    <v-btn
                        class="ma-2"
                        text
                        icon
                        color="red lighten-2"
                        @click="removerFiltro(f.nome)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-row>
            <v-col cols="2" offset="10">
              <v-btn
                  color="primary"
                  class="button btn-default white--text mt-4"
                  @click="listarCotas()"
              >
                Filtrar
              </v-btn
              >
            </v-col
            >
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import DataTable from '../components/DataTable'
  import { alert } from '@/plugins/helpers'

  export default {
    name: 'Cotas',
    components: { DataTable },
    data: () => ({
      cotas: [],
      search: '',
      selected: [],
      dialog: false,
      tiposFiltro: [
        { text: 'Nome do Cliente', value: 'nomeCliente', tipo: 'text' },
        { text: 'Grupo', value: 'grupo', tipo: 'number' },
        { text: 'Cota', value: 'numeroCota', tipo: 'number' },
        { text: 'CPF/CNPJ', value: 'cpfcnpj', tipo: 'text' },
        { text: 'Situação da Cota', value: 'situacaoCota', tipo: 'text' },
        { text: 'Produto', value: 'produto', tipo: 'text' },
        {
          text: 'Número de Parcelas Atrasadas (Mínimo)',
          value: 'numeroParcelasAtrasadasMin',
          tipo: 'number'
        },
        {
          text: 'Número de Parcelas Atrasadas (Máximo)',
          value: 'numeroParcelasAtrasadasMax',
          tipo: 'number'
        },
        {
          text: 'Data Próximo Vencimento Parcela (Início)',
          value: 'dataProximoVencimentoParcelaInicio',
          tipo: 'date'
        },
        {
          text: 'Data Próximo Vencimento Parcela (Fim)',
          value: 'dataProximoVencimentoParcelaFim',
          tipo: 'date'
        },
        {
          text: 'Situação Cobrança',
          value: 'situacaoCobranca',
          tipo: 'text'
        },
        {
          text: 'Data de Nascimento do Cliente (Início)',
          value: 'dataNascimentoClienteInicio',
          tipo: 'date'
        },
        {
          text: 'Data de Nascimento do Cliente (Fim)',
          value: 'dataNascimentoClienteFim',
          tipo: 'date'
        },
        {
          text: 'Data de Contemplação (Início)',
          value: 'dataContemplacaoInicio',
          tipo: 'date'
        },
        {
          text: 'Data de Contemplação (Fim)',
          value: 'dataContemplacaoFim',
          tipo: 'date'
        },
        {
          text: 'Data de Entrega do Bem (Início)',
          value: 'dataEntregaBemInicio',
          tipo: 'date'
        },
        {
          text: 'Data de Entrega do Bem (Fim)',
          value: 'dataEntregaBemFim',
          tipo: 'date'
        },
        {
          text: 'Data de Cancelamento (Início)',
          value: 'dataCancelamentoInicio',
          tipo: 'date'
        },
        {
          text: 'Data de Cancelamento (Fim)',
          value: 'dataCancelamentoFim',
          tipo: 'date'
        },
        {
          text: 'Data da Primeira Assembléia (Início)',
          value: 'dataPrimeiraAssembleiaInicio',
          tipo: 'date'
        },
        {
          text: 'Data da Primeira Assembléia (Fim)',
          value: 'dataPrimeiraAssembleiaFim',
          tipo: 'date'
        },
        {
          text: 'Data da Próxima Assembléia (Início)',
          value: 'dataProximaAssembleiaInicio',
          tipo: 'date'
        },
        {
          text: 'Data da Próxima Assembléia (Fim)',
          value: 'dataProximaAssembleiaFim',
          tipo: 'date'
        },
        {
          text: 'Assembléias',
          value: 'assembleias',
          tipo: 'text'
        },
        {
          text: 'ID da Cota',
          value: 'cotaID',
          tipo: 'number'
        },
        {
          text: 'Código Sub Produto',
          value: 'codigoSubproduto',
          tipo: 'text'
        },
        {
          text: 'Data da Última Assembléia (Início)',
          value: 'dataUltimaAssembleiaInicio',
          tipo: 'date'
        },
        {
          text: 'Data da Última Assembléia (Fim)',
          value: 'dataUltimaAssembleiaFim',
          tipo: 'date'
        },
        {
          text: 'Modalidade Contemplação',
          value: 'modalidadeContemplacao',
          tipo: 'text'
        },
        {
          text: 'Data de Vencimento Mais Atrasada (Início)',
          value: 'dataVencimentoMaisAtrasadaInicio',
          tipo: 'date'
        },
        {
          text: 'Data de Vencimento Mais Atrasada (Fim)',
          value: 'dataVencimentoMaisAtrasadaFim',
          tipo: 'date'
        },
        {
          text: 'Código da Unidade de Negócio',
          value: 'codigoUnidadeNegocio',
          tipo: 'text'
        },
        {
          text: 'Tipo Pessoa',
          value: 'tipoPessoa',
          tipo: 'text'
        },
        {
          text: 'Quantidade de Parcelas Pagas (Mínimo)',
          value: 'quantidadeParcelasPagasMin',
          tipo: 'number'
        },
        {
          text: 'Quantidade de Parcelas Pagas (Máximo)',
          value: 'quantidadeParcelasPagasMax',
          tipo: 'number'
        },
        {
          text: 'Débito Automático',
          value: 'debitoAutomatico',
          tipo: 'text'
        },
        {
          text: 'Contemplado',
          value: 'contemplado',
          tipo: 'text'
        }
      ],
      filtrosIncluidos: [],
      filtroPreenchido: { nome: '', descricao: '', valor: '' },
      cotasIncluidas: [],
      tipoFiltroSelecionado: '',
      selectedHeaders: [],
      headers: [],
      headersMap: [
        { text: 'Nome do Cliente', value: 'nomeCliente' },
        { text: 'Grupo', value: 'grupo' },
        { text: 'Cota', value: 'numeroCota' },
        { text: 'CPF/CNPJ', value: 'cpfcnpj' },
        { text: 'Situação da Cota', value: 'situacaoCota' },
        { text: 'Produto', value: 'produto' },
        {
          text: 'Número de Parcelas Atrasadas',
          value: 'numeroParcelasAtrasadas'
        },
        {
          text: 'Data Próximo Vencimento Parcela',
          value: 'dataProximoVencimentoParcela'
        },
        { text: 'Situação Cobrança', value: 'situacaoCobranca' },
        { text: 'Data de Nascimento do Cliente', value: 'dataNascimentoCliente' },
        { text: 'Data de Contemplação', value: 'dataContemplacao' },
        { text: 'Data de Entrega do Bem', value: 'dataEntregaBem' },
        { text: 'Data de Cancelamento', value: 'dataCancelamento' },
        { text: 'Data da Primeira Assembléia', value: 'dataPrimeiraAssembleia' },
        { text: 'Data da Próxima Assembléia', value: 'dataProximaAssembleia' },
        { text: 'Assembléias', value: 'assembleias' },
        { text: 'ID da Cota', value: 'cotaID' },
        { text: 'Código do Sub Produto', value: 'codigoSubproduto' },
        { text: 'Data da Última Assembléia', value: 'dataUltimaAssembleia' },
        { text: 'Modalidade Contemplação', value: 'modalidadeContemplacao' },
        {
          text: 'Data de Vencimento Mais Atrasada',
          value: 'dataVencimentoMaisAtrasada'
        },
        { text: 'Código da Unidade de Negócio', value: 'codigoUnidadeNegocio' },
        { text: 'Tipo Pessoa', value: 'tipoPessoa' },
        {
          text: 'Quantidade de Parcelas Pagas',
          value: 'quantidadeParcelasPagas'
        },
        { text: 'Débito Automático', value: 'debitoAutomatico' },
        { text: 'Contemplado', value: 'contemplado' },
        { text: 'ID', value: 'id' },
        { text: 'Status', value: 'status' }
      ]
    }),
    computed: {
      filtrosOrdenados () {
        return this.tiposFiltro.sort((a, b) =>
          a.descricao > b.descricao ? 1 : b.descricao > a.descricao ? -1 : 0
        )
      },

      showHeaders () {
        return this.headers.filter((s) => this.selectedHeaders.includes(s))
      }
    },
    mounted () {
      this.listarCotas()

      if (window.localStorage.getItem('cotasIncluidas') !== null) { this.cotasIncluidas = JSON.parse(window.localStorage.getItem('cotasIncluidas')) }
    },
    created () {
      let hm = this.headersMap.sort((a, b) =>
        a.text > b.text ? 1 : b.text > a.text ? -1 : 0
      )

      this.headers = Object.values(hm)

      var inicial = ['nomeCliente', 'cpfcnpj', 'grupo', 'numeroCota']

      this.selectedHeaders = this.headers.filter((x) => {
        return inicial.indexOf(x.value) >= 0
      })
    },
    methods: {
      listarCotas () {
        this.loading = true

        return this.$http
          .post(
            '/Cota?offSet=0&limit=0',
            this.filtrosIncluidos.length === 0
              ? {}
              : this.converterFiltrosEmObjeto()
          )
          .then((res) => {
            this.items = []
            this.$nextTick(() => {
              this.cotas = res.data
            })
          })
          .catch(() => {
          // cancel
          })
          .finally(() => {
            this.loading = false
            this.dialog = false
          })
      },
      incluirFiltro () {
        let data =
          this.tipoFiltroSelecionado === 'date'
            ? this.filtroPreenchido.valor
            : ''

        data =
          data.split('-')[2] +
          '/' +
          data.split('-')[1] +
          '/' +
          data.split('-')[0]

        let filtroPreenchido = {
          nome: this.filtroPreenchido.nome,
          descricao: this.tiposFiltro.find(
            (x) => x.value === this.filtroPreenchido.nome
          ).text,
          valor:
            this.tipoFiltroSelecionado === 'date'
              ? data
              : this.filtroPreenchido.valor
        }

        this.filtrosIncluidos.push(filtroPreenchido)
      },
      removerFiltro (nome) {
        this.filtrosIncluidos = this.filtrosIncluidos.filter(
          (x) => x.nome !== nome
        )
      },
      incluirCotas () {
        this.selected.forEach((x) => {
          this.cotasIncluidas.push(x)
        })

        alert('Cotas Incluídas com Sucesso')
      },
      retornaTipoCampoFiltro (valor) {
        this.tipoFiltroSelecionado = this.tiposFiltro.filter((x) => {
          return x.value === valor
        })[0].tipo
      },
      converterFiltrosEmObjeto () {
        var objeto = this.filtrosIncluidos.reduce(
          (obj, item) => Object.assign(obj, { [item.nome]: item.valor }),
          {}
        )

        return objeto
      },
      menuRoute (name) {
        try {
          const route = this.$router.resolve({ name }).route
          const selected = this.$route.path.startsWith(route.path)
          return route.matched.length
            ? { text: route.meta.title, to: route.path, selected }
            : { text: '// fixme' }
        } catch (e) {
          return false
        }
      },
      acessar (item) {
        if (item.click) {
          item.click()
        } else {
          try {
            if (this.$route.path !== item.to) {
              this.$router.push(item.to)
            }
          } catch (e) {
            return false
          }
        }
      },
      criarNotificacao () {
        window.localStorage.setItem('cotasIncluidas', JSON.stringify(this.cotasIncluidas))

        this.acessar(this.menuRoute('notificacaoAvulsa'))
      }
    }
  }
</script>
